import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AngularEditorComponent, AngularEditorConfig } from "@kolkov/angular-editor";
import { Observable, map, startWith } from "rxjs";
import { MyErrorStateMatcher } from "src/app/auth/login/login.component";
import { UserService } from "src/app/shared/user.service";
import { NotificationService } from "../shared/notification.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-notification-form",
  templateUrl: "./notification-form.component.html",
  styleUrls: ["./notification-form.component.css"],
})
export class NotificationFormComponent implements OnInit {
  @ViewChild('emailBodyTextarea') emailBodyTextarea: AngularEditorComponent;

  matcher = new MyErrorStateMatcher();
  notificationForm: FormGroup;
  notificationTypes: any = ["Action Based", "User Based"];
  notifications: any[] = [];
  notificationTriggers: any[] = [];

  values: string[] = [];
  contractTypes: any;
  isLoading = false;
  editorConfig: AngularEditorConfig = {
    editable: false,
    showToolbar: false,
    height: '250px',
    defaultFontSize: '3',
    toolbarHiddenButtons: [
      ['insertImage']
    ]
  };

  formLoading = false;
  id: any;
  mode: any;
  filteredOptions: Observable<string[]>;
  isNotFound: boolean = false;
  defaultAttributes: any = ["Contract Id", "Contract Name", "Contract Status"];
  metaData: any;
  users: any[] = [];
  roles: any[] = [];

  constructor(
    public userService: UserService,
    public service: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private toast: ToastrService
  ) {
    this.route.params.subscribe(params => {
      this.id = params['id'];
      this.mode = params['mode'];
    });

    if (this.id)
      this.formLoading = true;

    this.notificationForm = this.fb.group({
      notificationName: ["", Validators.required],
      notificationType: ["", Validators.required],
      contractTypeName: ['', [Validators.required]],
      contractTypeId: [0],
      actionId: [null, Validators.required],
      ccEmailTo: [null],
      sendEmailTo: [null, Validators.required],
      emailSubject: ["", Validators.required],
      emailBody: ["", Validators.required],
      users: [""],
      ccUsers: [""],
    });

    if (this.mode == 'view') {
      this.notificationForm.disable();
    } else {
      this.editorConfig.editable = true;
      this.notificationForm.enable();
      this.editorConfig.showToolbar = true;
    }

  }
  async ngOnInit() {

    await this.service.getNotificationTrigger().then((res) => {
      this.notificationTriggers = res as Array<Object>;
    });
    await this.service.getNotificationData().then((notification: any) => {
      this.notifications = notification
    })

    await this.service.getContractType().then((res) => {
      this.contractTypes = res as Array<Object>;
      // this.contractTypes.unshift({ contractTypeId: null, name: 'All' });
    });

    await this.service.getContractRoles().then((res) => {
      this.roles = res as Array<Object>;
    });

    await this.userService.getAllTenantUsers().then((res) => {
      this.users = res as Array<Object>;
    });

    this.notificationForm.get('sendEmailTo').valueChanges.subscribe(() => {
      this.updateUsersRequired();
    });
    this.notificationForm.get('ccEmailTo').valueChanges.subscribe(() => {
      this.updateUsersRequired();
    });

    if (this.contractTypes) {
      this.filteredOptions = this.notificationForm.get('contractTypeName').valueChanges.pipe(
        startWith(''),
        map(value => this._filter(((value as string)) || ''))
      );
    }

    if (this.id) {
      await this.service.getNotificationDetails(this.id).then((res: any) => {
        this.notificationForm.get('notificationName').setValue(res.body[0].notificationEntity?.notificationName);
        this.notificationForm.get('notificationType').setValue(res.body[0].notificationEntity?.notificationType);
        this.notificationForm.get('emailSubject').setValue(res.body[0].notificationEntity?.emailSubject);
        this.notificationForm.get('emailBody').setValue(res.body[0].notificationEntity?.emailBody);
        this.notificationForm.get('contractTypeId').setValue(res.body[0].notificationEntity?.contractTypeId);
  

        const selectedAction = this.notificationTriggers.find(option => option.actionId === res.body[0].notificationEntity?.notificationActionId);
        if (selectedAction)
          this.notificationForm.get('actionId').setValue(selectedAction.actionId);

        const selectedContract = this.contractTypes.find(option => option.contractTypeId === res.body[0].notificationEntity?.contractTypeId);
        if (selectedContract)
          this.notificationForm.get('contractTypeName').setValue(selectedContract.name);
        // else
        //   this.notificationForm.get('contractTypeName').setValue('All');

        if (res.body[0]?.sendEmailToRole) {
          const contractSendRoleIds = res.body[0]?.sendEmailToRole
            .filter(entry => entry.recipientType === 'SEND')
            .map(entry => entry.contractRoleId);

          this.notificationForm.get('sendEmailTo').setValue(contractSendRoleIds);
        }

        if (res.body[0]?.ccEmailToRole) {
          const contractCCRoleIds = res.body[0]?.ccEmailToRole
            .filter(entry => entry.recipientType === 'CC')
            .map(entry => entry.contractRoleId);

          this.notificationForm.get('ccEmailTo').setValue(contractCCRoleIds);
        }

        if (res.body[0]?.users) {
          const contractUsers = res.body[0]?.users
            .filter(entry => entry.recipientType === 'SEND')
            .map(entry => entry.userId);
          if (contractUsers) {
            this.updateUsersRequired();
            this.notificationForm.get('users').setValue(contractUsers);
          }
        }

        if (res.body[0]?.users) {
          const contractCCUsers = res.body[0]?.users
            .filter(entry => entry.recipientType === 'CC')
            .map(entry => entry.userId);
          if (contractCCUsers) {
            this.updateUsersRequired();
            this.notificationForm.get('ccUsers').setValue(contractCCUsers);
          }
        }
      });
      await this.service.getContractMetadata(this.notificationForm.get('contractTypeId').value).then((res: any) => {
        this.metaData = [...this.defaultAttributes, ...res,];
        console.log(this.metaData,"res")
      });
    }

    this.formLoading = false;

  }

  private _filter(value: string): any[] {
    this.isNotFound = false;
    const filterValue = value.toLowerCase();
    const results = this.contractTypes.filter(option => option.name.toLowerCase().includes(filterValue));
    if (results.length === 0)
      this.isNotFound = true

    return results;
  }

  updateUsersRequired() {
    const sendEmailToValue = this.notificationForm.get('sendEmailTo').value || [];
    const ccEmailToValue = this.notificationForm.get('ccEmailTo').value || [];
    // Check if user id 1 is selected in either sendEmailTo or ccEmailTo
    const showUsers = sendEmailToValue.includes(1);
    const showCCUsers = ccEmailToValue.includes(1);
    // Update the "required" validator for the users control based on visibility
    const usersControl = this.notificationForm.get('users');
    const ccUsersControl = this.notificationForm.get('ccUsers');

    if (showUsers) {
      usersControl.setValidators(Validators.required);
    } else {
      usersControl.clearValidators();
      this.notificationForm.get('users').setValue(null);
    }

    if (showCCUsers) {
      ccUsersControl.setValidators(Validators.required);
    } else {
      ccUsersControl.clearValidators();
      this.notificationForm.get('ccUsers').setValue(null);
    }
    usersControl.updateValueAndValidity(); // Update the validation status
    ccUsersControl.updateValueAndValidity(); // Update the validation status
  }


  insertMeta(meta: string) {
    const emailBodyControl = this.notificationForm.get('emailBody');
    // const subjectBody = this.notificationForm.get('emailSubject')
    const currentEmailBodyValue = emailBodyControl.value;
    // const currentSubjectBodyValue = subjectBody.value
    // Append the metadata value to the email body
    const newEmailBodyValue = currentEmailBodyValue + '<b>' + meta + '</b>';
// const newSubjectBody = currentSubjectBodyValue + '<b>' + meta + '</b>';
    // Update the email body value in the form
    emailBodyControl.setValue(newEmailBodyValue);
    // subjectBody.setValue(newSubjectBody)
    this.emailBodyTextarea.focus();
  }


  onInputChange(value: string) {
    this.filteredOptions = this.notificationForm.get('contractTypeName').valueChanges.pipe(
      startWith(value),
      map(val => this._filter((val as string) || ''))
    );
  }

  reset() {
    this.notificationForm.reset();
  }

  async onContractTypeSelect(event) {
    this.notificationForm.get('contractTypeName').setValue(event.option.value.name);
    this.notificationForm.get('contractTypeId').setValue(event.option.value.contractTypeId ?? 0);

    if (this.contractTypes) {
      this.filteredOptions = this.notificationForm.get('contractTypeName').valueChanges.pipe(
        startWith(''),
        map(value => this._filter((value as string) || ''))
      );
    }

    await this.service.getContractMetadata(event.option.value.contractTypeId).then((res: any) => {
      this.metaData = [...this.defaultAttributes, ...res,  ];
  
    });
  }

  async saveNotification() {
    if (this.notificationForm.valid) {
      this.isLoading = true;
      const formData = this.notificationForm.value;
      if (this.id) {
        try {
          await this.service.updateNotification(formData, this.id).then((res) => {
            this.toast.success('The Notification has been Updated successfully');
          })
          this.reset();
          this.router.navigate(["app/notification/list"]);
          this.isLoading = false
        } catch {
          this.toast.error('Something went wrong! Please try again later.', '');
          this.isLoading = false
        }
      } else {
        try {
          await this.service.saveNotification(formData).then((res) => {
            this.toast.success('The Notification has been Created successfully');
          })
          this.reset();
          this.router.navigate(["app/notification/list"]);
          this.isLoading = false
        } catch {
          this.toast.error('Something went wrong! Please try again later.', '');
          this.isLoading = false
        }
      }
    };

  }
}
